import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-parameters-users',
  templateUrl: './parameters-users.component.html',
  styleUrls: ['./parameters-users.component.less']
})
export class ParametersUsersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/element/parameters-users/parameters-users.component.ts